import React from 'react';
import Shared from 'screens/shared';
import { capitalize } from 'utils';

export default ({ groupActions = [] }) => (
  <Shared.widgets.Section
    items={groupActions}
    sectionTitle="Actions"
    setItemTitle={(e) => `${e.actionType?.replace('_', ' ')} - ${capitalize(e.actionStatus)}`}
    setItemDetails={(e) => <span>{`Capacity: ${e.targetReplicaCount}, Date: ${new Date(e.metadata?.createdDate).toLocaleString()}`}</span>}
    itemIcon="expand-arrows-alt"
  />
);
